import i18n from '@/utils/i18n';
import React from 'react';
import SnapPeas from '@assets/icons/snap-peas-image.svg';
import { EmptyStateMinimal } from '@/components/empty-state-minimal';
import { ExternalContentHolisticsDashboard } from './external-content-holistics-dashboard';
import { ExternalContentTool } from './external-content-tool';
import { ExternalContentURLTypes } from '@/enums';
import { useExternalContent } from '@/contexts/external-content-context';
import { useTheme } from '@/contexts/theme-context';

export const ExternalContentWrapper: React.FC = () => {
  const theme = useTheme();
  const { selectedExternalContent } = useExternalContent();

  let externalContentComponent = null;
  switch (selectedExternalContent?.config.type) {
    case ExternalContentURLTypes.HOLISTICS_DASHBOARD:
      externalContentComponent = (
        <ExternalContentHolisticsDashboard
          externalContent={selectedExternalContent}
        />
      );
      break;
    case ExternalContentURLTypes.TOOL:
      externalContentComponent = (
        <ExternalContentTool externalContent={selectedExternalContent} />
      );
      break;
  }

  return (
    externalContentComponent ?? (
      <EmptyStateMinimal
        iconProps={{
          accentFill: theme.colors.accent,
          fill: theme.colors.primary,
        }}
        ImageComponent={SnapPeas}
        text={i18n.t('external_content.invalid_url')}
      />
    )
  );
};
